export class ImageApproveMultipleModel {
    public imageId: number;
    public priceForSmall: number;
    public priceForMedium: number;
    public priceForLarge: number;
}
